<div class="ngx-guided-tour-steps-bullet">
    <ng-container *ngFor="let bullet of bullets">
        <span class="d-block bullet" [ngClass]="{ actived: bullet === stepActived }"></span>
    </ng-container>
</div>
